module.exports = __webpack_public_path__ + "static/media/bad.c8bd587a.png";